import z from "zod";
import { optionalFilterString } from "@/schemas/filter.schema";

export const driverFilterSchema = z.object({
	search: optionalFilterString,
});
